import {FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, ValidationErrors} from '@angular/forms';
import { GatewayPasswordConfigModel } from '../services/gateway-config/gatewayPasswordConfig.model';

export class CustomValidators {
  public static checkPasswords(group: FormGroup): ValidationErrors {
    const newPin = group.get('newPassword').value;
    const newPinRepeat = group.get('newPasswordRepeat').value;

    return newPin === newPinRepeat ? null : { notMatching: true };
  }

  public static passwordSecurity(settings: GatewayPasswordConfigModel): any {
    return (control: FormControl): ValidationErrors => {
      const value = (control.value || '').toString();

      if (settings.minLength > 0 && value.length < settings.minLength) {
        return { tooShort: true };
      }

      if (settings.maxLength > 0 && value.length > settings.maxLength) {
        return { tooLong: true };
      }

      if (settings.minCategories > 0) {
        let categories = 0;

        if (value.match(/[A-Z]/g)) {
          categories++;
        }
        if (value.match(/[a-z]/g)) {
          categories++;
        }
        if (value.match(/[\d]/g)) {
          categories++;
        }
        if (value.match(/[\W]/g)) {
          categories++;
        }

        if (categories < settings.minCategories) {
          return { insecure: true };
        }
      }

      return null;
    };
  }
}
